import './StatsCounter.css';
import { useTranslation } from 'react-i18next';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';

interface StatsCounterProps {
	type: 'views' | 'favorites';
	count: number;
	placement:
		| 'top'
		| 'top-start'
		| 'top-end'
		| 'right'
		| 'right-start'
		| 'right-end'
		| 'bottom'
		| 'bottom-start'
		| 'bottom-end'
		| 'left'
		| 'left-start'
		| 'left-end';
	distance: number;
}

const StatsCounter = ({ type, count, placement, distance }: StatsCounterProps) => {
	const { t } = useTranslation();

	let content;
	if (type === 'views') {
		content = count === 1 ? t('1 view') : t('{n} views').replace('{n}', String(count));
	} else {
		content =
			count === 1
				? t('Added to favorites 1 time')
				: t('Added to favorites {n} times').replace('{n}', String(count));
	}

	return (
		<SlTooltip
			content={content}
			placement={placement}
			distance={distance}
			className='stats-counter__tooltip'
		>
			<div className='stats-counter'>
				{type === 'views' ? <SlIcon name='eye' /> : <SlIcon name='heart' />}
				{count}
			</div>
		</SlTooltip>
	);
};

export { StatsCounter };
